"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_core_1 = require("@patternfly/react-core");
const LoadingState = ({ content, primaryAction, secondaryActions }) => (react_1.default.createElement(react_core_1.Bullseye, null,
    react_1.default.createElement(react_core_1.EmptyState, { variant: react_core_1.EmptyStateVariant.sm },
        react_1.default.createElement(react_core_1.Spinner, { size: "xl" }),
        content && react_1.default.createElement(react_core_1.EmptyStateBody, null, content),
        primaryAction,
        secondaryActions && react_1.default.createElement(react_core_1.EmptyStateActions, null, secondaryActions))));
exports.default = LoadingState;
//# sourceMappingURL=LoadingState.js.map